import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

export const NAV_ITEMS = [
  { label: "首页", to: "/" },
  { label: "娱乐资讯", to: "/category/news" },
  { label: "影视推荐", to: "/category/recommendations" },
  { label: "明星动态", to: "/category/stars" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [mobileKeyword, setMobileKeyword] = useState("");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const submitSearch = (value: string) => {
    const q = value.trim();
    if (!q) return;
    setKeyword("");
    setMobileKeyword("");
    setMenuOpen(false);
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur transition-shadow duration-300 ${
        scrolled ? "shadow-[0_1px_0_0_oklch(var(--background-300))]" : ""
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] w-full items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2" aria-label="蜜桃33 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg" />
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
            蜜桃<span className="text-primary-600">33</span>
          </span>
        </Link>

        <nav className="hidden flex-1 items-center justify-center gap-1 md:flex">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-[15px] font-medium transition-colors ${
                  isActive
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            submitSearch(keyword);
          }}
          className="relative ml-auto hidden w-56 items-center lg:flex"
        >
          <i className="ri-search-line pointer-events-none absolute left-3 text-base text-foreground-400" />
          <input
            type="search"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索资讯、影视或明星"
            aria-label="站内搜索"
            className="h-10 w-full rounded-md border border-background-300 bg-background-100 pl-9 pr-3 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50"
          />
        </form>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
        </button>

        <button
          type="button"
          onClick={() => navigate("/search")}
          aria-label="打开搜索"
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
        >
          <i className="ri-search-line text-xl" />
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              submitSearch(mobileKeyword);
            }}
            className="relative mb-3 flex items-center"
          >
            <i className="ri-search-line pointer-events-none absolute left-3 text-base text-foreground-400" />
            <input
              type="search"
              value={mobileKeyword}
              onChange={(e) => setMobileKeyword(e.target.value)}
              placeholder="搜索资讯、影视或明星"
              aria-label="站内搜索"
              className="h-11 w-full rounded-md border border-background-300 bg-background-100 pl-9 pr-3 text-sm text-foreground-800 outline-none placeholder:text-foreground-400 focus:border-primary-400"
            />
          </form>
          <nav className="flex flex-col">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-md px-3 py-3 text-[15px] font-medium ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-400" />
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}